import Text from "@/components/Text";
import { Box, UnstyledButton, useMantineTheme } from "@mantine/core";
import styles from "./index.module.css";
import { useState } from "react";
import { type ContextModalProps } from "@mantine/modals";
import { ArrowLeft, ArrowRight, ElectricityHollow, Gas, HomeAddSolution } from "@/components/Icons";
import { useTranslation } from "@/i18n/client";
import { Trans } from "react-i18next";
import IconBackground from "@/components/IconBackground";
import { useContractState } from "@/hooks/useContractState";
import { Commodity } from "@/types/contract";

export const mapHelpModalContext = {
  modal: "mapHelp",
  innerProps: {},
};

export const MapHelp = ({ context, id }: ContextModalProps) => {
  const { t } = useTranslation("map");
  const { contract } = useContractState();
  const [page, setPage] = useState(0);

  const isGas = contract.supplyPoint.commodity === Commodity.Gas;

  return (
    <Box pos="relative">
      <div className={styles.container}>
        <div className={styles.content}>
          <Text variant="reading_small" mb={8}>
            {page + 1}/4
          </Text>
          <Text variant="reading_medium_bold" mb={18}>
            {t(isGas ? titleGas[page]! : title[page]!)}
          </Text>
          <Text variant="reading_medium">
            <Trans
              t={t}
              i18nKey={isGas ? messageGas[page]! : message[page]!}
              components={{
                icon: <Icon page={page} isGas={isGas} />,
              }}
            />
          </Text>
        </div>
        <div className={styles.buttonToolbar}>
          <div>
            {page > 0 && (
              <UnstyledButton onClick={() => setPage(page - 1)} className={styles.button}>
                <ArrowLeft width={24} height={24} />
                <Text variant="reading_small_bold">{t("help.back")}</Text>
              </UnstyledButton>
            )}
          </div>
          <div>
            <UnstyledButton onClick={() => (page === 3 ? context.closeModal(id) : setPage(page + 1))} className={styles.button}>
              {page !== 3 && <ArrowRight width={24} height={24} />}
              <Text variant="reading_small_bold">
                {page === 0 ? t("help.forward") : page === 3 ? t("help.end") : t("help.next")}
              </Text>
            </UnstyledButton>
          </div>
        </div>
      </div>
    </Box>
  );
};

interface IconProps {
  page: number;
  isGas: boolean;
}

const Icon = ({ page, isGas }: IconProps) => {
  const theme = useMantineTheme();

  return (
    <div className={styles.icon}>
      <IconBackground width={26} height={26}>
        {page === 1 ? (
          <HomeAddSolution width={20} height={20} color={theme.colors.red[5]} />
        ) : isGas ? (
          <Gas width={20} height={20} color={theme.colors.red[5]} />
        ) : (
          <ElectricityHollow width={20} height={20} color={theme.colors.red[5]} />
        )}
      </IconBackground>
    </div>
  );
};

const title = ["help.page0Title", "help.page1Title", "help.page2Title", "help.page3Title"] as const;
const titleGas = ["help.page0Title", "help.page1Title", "help.page2TitleGas", "help.page3Title"] as const;
const message = ["help.page0Description", "help.page1Description", "help.page2Description", "help.page3Description"] as const;
const messageGas = [
  "help.page0DescriptionGas",
  "help.page1Description",
  "help.page2Description",
  "help.page3Description",
] as const;
